export const FormHelper = (() => {
  const handleChange = (event, stateSetter) => {
    const { name, value } = event.target;
    stateSetter((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return {
    handleChange,
    handleSubmit,
  };
})();
